import { Injectable } from "@angular/core";

import { OverflowErrorsEnum } from "../../core/enums/overflow-errors.enum";
import { IOverflowError } from "../../core/interfaces/overflow-error.interface";

@Injectable({
  providedIn: "root",
})
export class OverflowErrorsDataService {
  getOverflowErrorsData(): IOverflowError[] {
    return [
      {
        icon: "../../../../assets/images/darts.svg",
        errorCode: OverflowErrorsEnum.EXCEEDED_MAXIMUM_NUMBER_ATTEMPTS_CUSTOMER,
        title: "Superaste el máximo de intentos",
        description: `Te recomendamos revisar el documento y vuelve a intentarlo cuando tu asesor se ponga en contacto contigo.`,
        captionButtom: "Entendido",
        url: "welcome",
      },
      {
        icon: "../../../../assets/images/icecream.svg",
        errorCode: OverflowErrorsEnum.TECHNICAL_ERROR,
        title: "Algo no salió bien…",
        description:
          "En este momento tenemos incovenientes técnicos. Pronto estaremos funcionando. Por favor, vuelve en un momento.",
        captionButtom: "Salir",
        url: "welcome",
      },
      {
        icon: "../../../../assets/images/on-hold.svg",
        errorCode: OverflowErrorsEnum.PayrollCheckUpload001,
        title: "No podemos continuar",
        description:
          "Lo sentimos, no tenemos un proceso activo con la cédula que ingresaste. Comunícate con tu asesor para activar el proceso.",
        captionButtom: "Entendido",
        url: "welcome",
      },
      {
        icon: "../../../../assets/images/on-hold.svg",
        errorCode: OverflowErrorsEnum.PayrollCheckUpload002,
        title: "Ya recibimos tus documentos",
        description:
          "Tu asesor se pondrá en contacto contigo para continuar el proceso.",
        captionButtom: "Entendido",
        url: "welcome",
      },
      {
        icon: "../../../../assets/images/on-hold.svg",
        errorCode: OverflowErrorsEnum.PayrollCheckUpload003,
        title: "Algo no salió bien…",
        description:
          "En este momento tenemos incovenientes técnicos. Pronto estaremos funcionando. Por favor, vuelve en un momento.",
        captionButtom: "Entendido",
        url: "welcome",
      },
      {
        icon: "../../../../assets/images/on-hold.svg",
        errorCode: OverflowErrorsEnum.BucketFile001,
        title: "Algo no salió bien…",
        description:
          "En este momento tenemos incovenientes técnicos. Pronto estaremos funcionando. Por favor, vuelve en un momento.",
        captionButtom: "Entendido",
        url: "welcome",
      },
      {
        icon: "../../../../assets/images/on-hold.svg",
        errorCode: OverflowErrorsEnum.BucketFile002,
        title: "Algo no salió bien…",
        description:
          "En este momento tenemos incovenientes técnicos. Pronto estaremos funcionando. Por favor, vuelve en un momento.",
        captionButtom: "Entendido",
        url: "welcome",
      },
      {
        icon: "../../../../assets/images/on-hold.svg",
        errorCode: OverflowErrorsEnum.PayerPlatform02,
        title: "Algo no salió bien…",
        description:
          "En este momento tenemos incovenientes técnicos. Pronto estaremos funcionando. Por favor, vuelve en un momento.",
        captionButtom: "Entendido",
        url: "welcome",
      },
    ];
  }
}
